var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXBullRunLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205.6 72",
    style: {
      enableBackground: "new 0 0 205.6 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#3840CD;}\n\t.st2{fill:url(#Path_307_00000106134040621788034190000017312782354399395258_);}\n\t.st3{fill:url(#Path_308_00000130633712781479282380000007928006131030944141_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    transform: "translate(-55.737 -38.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9,100c0.7,0.9,1.1,2,1.1,3.1c0,1-0.3,1.9-0.8,2.7c-0.5,0.8-1.3,1.4-2.2,1.9c-1,0.5-2.1,0.7-3.4,0.7 h-7.8V88.9h7.4c1.3,0,2.5,0.2,3.4,0.7s1.7,1,2.2,1.8c0.5,0.8,0.7,1.6,0.7,2.5c0,1.1-0.3,2.1-0.9,2.8c-0.6,0.7-1.4,1.3-2.4,1.7 C147.3,98.6,148.2,99.1,148.9,100z M139.1,97.1h3.9c1,0,1.9-0.2,2.4-0.7s0.9-1.2,0.9-2.1c0-0.9-0.3-1.6-0.9-2.1 c-0.6-0.5-1.4-0.7-2.4-0.7h-3.9V97.1z M145.9,105c0.6-0.5,0.9-1.3,0.9-2.2c0-1-0.3-1.7-1-2.3c-0.7-0.6-1.5-0.8-2.6-0.8h-4.2v6.1 h4.3C144.5,105.8,145.3,105.5,145.9,105z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.7,88.9v12.4c0,1.5,0.4,2.6,1.2,3.3c0.8,0.7,1.9,1.1,3.2,1.1c1.4,0,2.5-0.4,3.3-1.1 c0.8-0.7,1.2-1.9,1.2-3.3V88.9h3.2v12.3c0,1.6-0.3,2.9-1,4c-0.7,1.1-1.6,1.9-2.8,2.5c-1.2,0.5-2.4,0.8-3.8,0.8 c-1.4,0-2.7-0.3-3.8-0.8c-1.1-0.5-2.1-1.4-2.7-2.5s-1-2.4-1-4V88.9H156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176,105.8h6.6v2.6h-9.8V88.9h3.2V105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.5,105.8h6.6v2.6h-9.8V88.9h3.2V105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.1,108.4l-4.5-7.8h-2.4v7.8H205V88.9h6.7c1.5,0,2.8,0.3,3.8,0.8c1,0.5,1.8,1.2,2.3,2.1 c0.5,0.9,0.8,1.9,0.8,2.9c0,1.3-0.4,2.4-1.1,3.5s-1.9,1.7-3.4,2.1l4.8,8.1H215.1z M208.2,98.1h3.5c1.2,0,2.1-0.3,2.7-0.9 c0.6-0.6,0.9-1.4,0.9-2.4s-0.3-1.8-0.9-2.4c-0.6-0.6-1.5-0.9-2.7-0.9h-3.5V98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.8,88.9v12.4c0,1.5,0.4,2.6,1.2,3.3c0.8,0.7,1.9,1.1,3.2,1.1c1.4,0,2.5-0.4,3.3-1.1 c0.8-0.7,1.2-1.9,1.2-3.3V88.9h3.2v12.3c0,1.6-0.3,2.9-1,4c-0.7,1.1-1.6,1.9-2.8,2.5c-1.2,0.5-2.4,0.8-3.8,0.8s-2.7-0.3-3.8-0.8 c-1.1-0.5-2.1-1.4-2.7-2.5s-1-2.4-1-4V88.9H225.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258,108.4h-3.2l-9.6-14.5v14.5H242V88.9h3.2l9.6,14.5V88.9h3.2V108.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    transform: "translate(-1140.313 -2484.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    transform: "translate(1196.05 2523.679)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_307_00000044142794103627560110000012335428151318342785_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.5948,
    y1: 291.6153,
    x2: -144.5108,
    y2: 291.6153,
    gradientTransform: "matrix(44.002 0 0 -66.149 6387.9707 19325.7461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopcolor: "#FF81F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopcolor: "#9225FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    style: {
      stopcolor: "#8318FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopcolor: "#7426FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    style: {
      stopcolor: "#3840CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopcolor: "#578EE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    style: {
      fill: "url(#Path_307_00000044142794103627560110000012335428151318342785_)"
    },
    d: "M50.5,2.6l-13.4,22 L26.6,35.4l10,11l13.9,22.3h20.1L47.3,35.1L70.4,2.6L50.5,2.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_308_00000111875324803814534300000007156947842992505271_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.6246,
    y1: 291.6152,
    x2: -144.5406,
    y2: 291.6152,
    gradientTransform: "matrix(44.3879 0 0 -66.147 6421.4189 19325.1562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopcolor: "#FF81F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    style: {
      stopcolor: "#9225FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    style: {
      stopcolor: "#8318FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopcolor: "#7426FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    style: {
      stopcolor: "#3840CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopcolor: "#578EE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    style: {
      fill: "url(#Path_308_00000111875324803814534300000007156947842992505271_)"
    },
    d: "M37.1,24.7l-12.5-22 H4.5l22.1,32.8L2.9,68.8h20.8l12.8-22.3l10.7-11.3L37.1,24.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    transform: "translate(1245.814 2524.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_309"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 1.6,
    className: "st1",
    width: 18.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_310"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 7.1,
    className: "st1",
    width: 22.1,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_313"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 17.9,
    className: "st1",
    width: 28.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_315"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 34.2,
    className: "st1",
    width: 40.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_311"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 12.5,
    className: "st1",
    width: 25.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_316"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 28.8,
    className: "st1",
    width: 36.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_312"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 23.4,
    className: "st1",
    width: 32.8,
    height: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBullRunLogo);
export default __webpack_public_path__ + "static/media/XBullRun_Logo.6777baf401e93c1bc540d062839576de.svg";
export { ForwardRef as ReactComponent };